import React from 'react'
import {createStyles} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";
import {withDataProvider, GET_ONE, showNotification} from 'react-admin'
import Button from "@material-ui/core/Button";
import FormDialog from '../../../elements/FormDialog'
import UsersSelect from '../../../elements/UsersSelect'
import DeactivateSegmentModal from '../DeactivateSegmentModal'

const styles = () => createStyles({
  button: {
    marginRight: '15px'
  },
})

const responseSuccess = {
  onSuccess: {
    notification: { body: 'Сохранено', level: 'info' },
  },
  onFailure: {
    notification: { body: 'Error', level: 'warning' },
  },
  refresh: true
}

const ButtonsGroupDirectorMo = withStyles(styles)(({classes, dataProvider, segmentId, statusId, experts, users}: any) => {

  const setCheckStatus = async (statusId, successText: boolean | string = false, mute = false) => {
    await dataProvider('SET_CHECK_STATUS', 'segments', {
      segmentId,
      data: {
        statusId
      }
    }, successText ? {
      onSuccess: {
        notification: { body: successText, level: 'info' },
      },
      onFailure: {
        notification: { body: 'Error', level: 'warning' },
      },
      refresh: true
    } : responseSuccess)
  }

  const setStatus = async (statusId, successText: boolean | string = false) => {
    await dataProvider('ASSIGN_EXPERT', 'segments', {
      segmentId,
      data: {
        status: 'assign',
        segmentStatusId: statusId // id assign
      }
    }, successText ? {
      onSuccess: {
        notification: { body: successText, level: 'info' },
      },
      onFailure: {
        notification: { body: 'Error', level: 'warning' },
      },
      redirectTo: `/segments/${segmentId}`,
      refresh: true
    } : responseSuccess)
  }

  const assignExpert = async (statusId, selectId, successText: boolean | string = false) => {
    const newExpert = (document.getElementById(selectId) as HTMLInputElement).value as unknown

    if (newExpert as number > 0) {
      await dataProvider('ASSIGN_EXPERT', 'segments', {
        segmentId,
        data: {
          toUserId: newExpert,
          status: 'assign',
          segmentStatusId: statusId // id assign
        }
      }, successText ? {
        onSuccess: {
          notification: { body: successText, level: 'info' },
        },
        onFailure: {
          notification: { body: 'Error', level: 'warning' },
        },
        refresh: true
      } : responseSuccess)
    } else {
      showNotification('Эксперт не выбран', 'warning')
    }
  }

  const checkNewExpert = async selectId => {
    const newExpert = (document.getElementById(selectId) as HTMLInputElement).value as unknown
    const error = []
    let checked = false

    experts.map(item => {
      if (item.id as number == newExpert as number) {
        checked = true
      }
    })
    if (checked) { error.push('Данный пользователь уже проверял этот сегмент, подтвердите повторное назначение эксперта') }

    const segmentInfo = await dataProvider(GET_ONE, 'segments', {
      id: segmentId,
      url: 'segments'
    })
    if (segmentInfo.data.verifyStatusId === 2) {error.push('Данный сегмент находится в работе, вы уверены, что хотите его переназначить?') }

    return {
      result: checked,
      error,
    }
  }

  return (
    <>
      {statusId === 1 && (
        <>
          <FormDialog
            label="Назначить эксперта"
            modalTitle="Назначить эксперта"
            content={<UsersSelect data={users.experts} id="users-select-experts" />}
            confirm={() => assignExpert(4, 'users-select-experts', 'Переведено на проверку')}
            className={classes.button}
            onBeforeConfirm={() => checkNewExpert('users-select-experts')}
          />
          <Button onClick={() => setStatus(4, 'Переведено на проверку')} color="primary" className={classes.button}>На проверку</Button>
          <DeactivateSegmentModal segmentId={segmentId} />
        </>
      )}

      {statusId === 4 && (
        <>
          <FormDialog
            label="Назначить эксперта"
            modalTitle="Назначить эксперта"
            content={<UsersSelect data={users.experts} id="users-select-experts" />}
            confirm={() => assignExpert(4, 'users-select-experts', 'Переведено на проверку')}
            className={classes.button}
            onBeforeConfirm={() => checkNewExpert('users-select-experts')}
          />
          <FormDialog
            label="Назначить НМО"
            modalTitle="Назначить НМО"
            content={<UsersSelect data={users.nmo} id="users-select-nmo" />}
            confirm={() => assignExpert(8, 'users-select-nmo')}
            className={classes.button}
            onBeforeConfirm={() => checkNewExpert('users-select-nmo')}
          />
          <Button onClick={() => setStatus(1, 'Возвращено в статус "Новый"')} className={classes.button}>Вернуть</Button>
          <DeactivateSegmentModal segmentId={segmentId} />
        </>
      )}

      {statusId === 8 && (
        <>
          <FormDialog
            label="Назначить эксперта"
            modalTitle="Назначить эксперта"
            content={<UsersSelect data={users.experts} id="users-select-experts" />}
            confirm={() => assignExpert(4, 'users-select-experts', 'Переведено на проверку')}
            className={classes.button}
            onBeforeConfirm={() => checkNewExpert('users-select-experts')}
          />
          <FormDialog
            label="Назначить корректора"
            modalTitle="Назначить корректора"
            content={<UsersSelect data={users.editors} id="users-select-editors" />}
            confirm={() => assignExpert(7, 'users-select-editors')}
            className={classes.button}
            onBeforeConfirm={() => checkNewExpert('users-select-editors')}
          />
          <Button onClick={() => setStatus(9, 'Возвращено на утверждение')} color="primary" className={classes.button}>На утверждение</Button>
          <Button onClick={() => setStatus(4, 'Возвращено на проверку')} className={classes.button}>Вернуть</Button>
          <DeactivateSegmentModal segmentId={segmentId} />
        </>
      )}

      {statusId === 7 && (
        <>
          <FormDialog
            label="Назначить главного методиста"
            modalTitle="Назначить главного методиста"
            content={<UsersSelect data={users.mainNmo} id="users-select-mainNmo" />}
            confirm={() => assignExpert(9, 'users-select-mainNmo')}
            className={classes.button}
            onBeforeConfirm={() => checkNewExpert('users-select-mainNmo')}
          />
          <Button onClick={() => setStatus(8, 'Возвращено на согласование')} className={classes.button}>Вернуть</Button>
          <DeactivateSegmentModal segmentId={segmentId} />
        </>
      )}

      {statusId === 9 && (
        <>
          <FormDialog
              label="Назначить главного методиста"
              modalTitle="Назначить главного методиста"
              content={<UsersSelect data={users.mainNmo} id="users-select-mainNmo" />}
              confirm={() => assignExpert(9, 'users-select-mainNmo')}
              className={classes.button}
              onBeforeConfirm={() => checkNewExpert('users-select-mainNmo')}
          />
          <Button onClick={() => setStatus(10, 'Сегмент утвержден')} color="primary" variant="outlined" className={classes.button}>Утвердить</Button>
          <Button onClick={() => setStatus(7, 'Возвращено на рецензирование')} className={classes.button}>Вернуть</Button>
          <DeactivateSegmentModal segmentId={segmentId} />
        </>
      )}

      {statusId === 10 && (
        <>
          <FormDialog
            label="Назначить НМО"
            modalTitle="Назначить НМО"
            content={<UsersSelect data={users.nmo} id="users-select-nmo" />}
            confirm={() => assignExpert(8, 'users-select-nmo')}
            className={classes.button}
            onBeforeConfirm={() => checkNewExpert('users-select-nmo')}
          />
          <Button onClick={() => setStatus(9, 'Возвращено на утверждение')} color="primary" className={classes.button}>Вернуть</Button>
          <Button onClick={() => setStatus(11, 'Переведено в статус "На экзамен"')} className={classes.button}>На экзамен</Button>
        </>
      )}

      {statusId === 11 && (
        <>
          <FormDialog
            label="Назначить эксперта"
            modalTitle="Назначить эксперта"
            content={<UsersSelect data={users.experts} id="users-select-experts" />}
            confirm={() => assignExpert(4, 'users-select-experts', 'Переведено на проверку')}
            className={classes.button}
            onBeforeConfirm={() => checkNewExpert('users-select-experts')}
          />
          <FormDialog
            label="Назначить НМО"
            modalTitle="Назначить НМО"
            content={<UsersSelect data={users.nmo} id="users-select-nmo" />}
            confirm={() => assignExpert(8, 'users-select-nmo')}
            className={classes.button}
            onBeforeConfirm={() => checkNewExpert('users-select-nmo')}
          />
          <Button onClick={() => setStatus(10, 'Сегмент утвержден')} color="primary" className={classes.button}>В утверждённые</Button>
          <DeactivateSegmentModal segmentId={segmentId} />
        </>
      )}
    </>
  )
})

export default withDataProvider(ButtonsGroupDirectorMo)